import * as types from './mutation-types'

export default {
    [types.LOAD_ORDERS] (state, data) {
        state.ordersLoaded = true
        state.orders = data
    },

    [types.SET_ORDERS] (state, orders) {
        state.ordersLoaded = true
        state.orders = state.orders.map(order => {
           let orderMap = orders.find(ord => ord.id === order.id)

            if(orderMap){
                order.status = orderMap.status
            }

            return order
        })
    },

    [types.UPDATE_ORDER] (state, order) {
        state.ordersLoaded = true
        state.orders = state.orders.map(ord => {

            if(ord.id === order.id){
                ord = order
            }
            return ord
        })
    },

    [types.VALIDATE_ORDER] (state, order) {
        state.ordersLoaded = true
        state.orders = state.orders.map(ord => {

            if(ord.id === order.id){
                ord.status = order.status
            }
            return ord
        })
    },

    [types.SET_ORDER] (state, order) {
        state.ordersLoaded = true
        state.orders = state.orders.map(ord => {

            if(ord.id === order.id){
                ord.status = order.status
            }
            return ord
        })
    },

    [types.CHANGE_ORDER] (state, {orderId, order}) {
        state.ordersLoaded = true
        state.orders = state.orders.map(ord => {
            if(ord.id === orderId){
                ord.meal_sale_elements = order
            }
            return ord
        })
    },

    
}

